import React, { forwardRef, useImperativeHandle, useRef } from "react"
import { useScrollRestoration } from "@/hooks/use-scroll-restoration.ts"
import { cn } from "@/utils/styles.ts"

interface PageContentWrapperLargeProps {
  children: React.ReactNode
  className?: string
}

const PageContentWrapperLarge = forwardRef<
  HTMLDivElement,
  PageContentWrapperLargeProps
>(({ children, className }, ref) => {
  const internalRef = useRef<HTMLDivElement>(null)

  useScrollRestoration(internalRef)
  useImperativeHandle(ref, () => internalRef.current!)

  return (
    <div
      ref={internalRef}
      className={cn(
        "box-border h-[calc(var(--scrollable-content-large))] w-full overflow-y-auto overflow-x-hidden md:h-full",
        "p-4 pb-12 md:pb-4",
      )}
    >
      <div
        className={cn(
          "mx-auto w-full md:w-5/6 lg:w-4/5 xl:w-3/5 2xl:w-2/5",
          className,
        )}
      >
        {children}
      </div>
    </div>
  )
})

PageContentWrapperLarge.displayName = "PageContentWrapperLarge"

export default PageContentWrapperLarge
